export function mixSelectableParent(key, eventName = 'change', valuePropName = 'value') {
  return {
    provide() {
      return {
        [key]: this
      }
    },
    props: {
      [valuePropName]: {
        type: [String, Number],
        required: true
      }
    },
    model: {
      prop: valuePropName,
      event: eventName
    },
    methods: {
      triggerChange(value) {
        this.$emit(eventName, value)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/utils/mix-selectable-parent.js